module.exports = __webpack_public_path__ + "img/hero-image-test.1064bdca.png";